// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1gFZc","spinner1":"Spinner_spinner1__mxJmp"};